import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavBar, DataTables,BreadCumb,TimeOut} from '../../components';
import {DISPATCH_ID, SERVICE_RESPONSE} from '../../libs/utils/Const';
import {ApiClient, ApiResponse} from '../../libs/apiClient';
import config from '../../config';
import moment from 'moment';
import $ from "jquery";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    {title: "Serie", value: true},
    {title: "Num.Doc", value: true},
    {title: "Cliente", value: true},
    {title: "Nombre", value: true},
    {title: "Fecha Cont.", value: true},
    {title: "Empl. Ventas", value: true},
    {title: "Titular Doc.", value: true},
    {title: "Comentarios", value: true},
    {title: "Total", value: true},
    {title: "Estatus", value: true},
    {title: "Fecha Entrega/ Vencimiento", value: true},
    {title: "Docs Vencidos", value: true},
    {title: "Facturado", value: true},
    {title: "Pagado", value: true},
    {title: "Vencido", value: true}]

class DeliveriesAuthorizationView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liEntreAuth");
        let today =  moment(new Date()).format('YYYYMMDD');

        let date= {
            dateInit:today,
            dateFinal:today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const {notificationReducer:  { showAlert }, enableSpinner } = this.props;
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            table: "ORDR",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--'
        };

        enableSpinner(true);
        let orderSalesListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if(orderSalesListResponse.status === SERVICE_RESPONSE.SUCCESS){
            this.setState({
                data: orderSalesListResponse.data,
            });
            return;
        }

        //showAlert({type: 'error', message: orderSalesListResponse.message});

    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    render() {
        const {headers, data, updateData,_user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <TimeOut/>
                <BreadCumb subitem1={'ORDEN DE VENTA - AUTORIZACIÓN'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;ORDEN DE VENTA - AUTORIZACIÓN
                        </a>
                    </h2>
                    <DataTables headers={headers} view={"orderSalesAuthorization"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliveriesAuthorizationView);
